<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import ConnxAvatar from '@/components/Atoms/ConnxAvatar.vue';
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';

const props = defineProps<{
  type: 'desktop' | 'mobile';
}>();

const style = [
  'background-color: var(--connx-navigation-background)',
  'color: var(--connx-navigation-text)',
].join(';');

const windowWidth = ref(window.innerWidth);
const windowResizeListener = (() => {
  windowWidth.value = window.innerWidth;
});

const links = computed(() => {
  if (windowWidth.value <= 900) {
    return [
      'My Team',
      '...',
    ]
  }
  return [
    'My Team',
    'My Details',
    'Company Info',
    'HR Admin',
    'Admin',
  ];
});

const height = computed(() => props.type === 'desktop' ? '23' : '25');
const width = computed(() => props.type === 'desktop' ? '100' : '129.73');
const svgLogo = computed(() => {
  return `<svg height="${height.value}" width="${width.value}" class="tw-shrink-0" style="height: ${height.value}px;" xmlns="http://www.w3.org/2000/svg"
          version="1.0" viewBox="0 0 560 130">
          <g fill="var(--connx-navigation-logo-fill)">
            <path
              d="M19.5 13.1C18.4 16.2 7.1 71.1 6 78.8 3 99 9 110.9 24.2 115.6c5.1 1.5 9.3 1.9 22.3 1.9 10 0 18.1-.6 21.5-1.4 11.6-2.9 19.9-9 24.5-18.1C95 93.2 99 81.5 99 79.3c0-1-2.6-1.3-11.7-1.3H75.5l-1.7 5.8C70.5 95 67 97 51 97c-10.9 0-15.9-1.1-18.6-4.1-3.8-4.2-1.2-26.1 6.7-56.2l1-3.7h15.8c18 0 21.1.4 24.1 3.2 1.8 1.7 2.1 2.9 1.8 7.4l-.3 5.4h24.2l.7-4.6C108.6 28 104 19 91.1 14.9c-6-2-9.3-2.2-38.8-2.7-26.6-.3-32.4-.2-32.8.9zm103 0c-.3.8-3.4 15.8-7 33.4-9 44.5-8.9 54.6 1 63.3 7.1 6.2 13.7 7.7 34 7.7 39.7-.1 49.5-9.3 59-55 3.5-16.6 3.8-29.1.8-35.5-2.7-6-7-9.5-15.1-12.1-6.2-2.1-9.1-2.3-39.4-2.7-26.9-.3-32.9-.2-33.3.9zM180.2 34c2 .6 4.7 2.3 5.9 3.8 1.8 2.4 2 3.5 1.5 9.2-1.1 12.7-7.3 36.8-10.8 42-4.1 6.1-7.8 7.5-21.3 7.8-13.7.4-19.2-.8-21.3-4.8-2-3.9-.9-14.1 4.2-37.3 2.5-11.5 4.6-21 4.6-21.3 0-.9 33.7-.3 37.2.6zm50.3-20.8c-.3.7-5.2 23.6-11 50.8-5.8 27.2-10.8 50.3-11.1 51.2-.5 1.7.5 1.8 12 1.8 6.9 0 12.6-.2 12.6-.4 0-.7 17.1-80.2 17.6-81.9.5-1.7 1.9-1.8 17.9-1.5 15.8.3 17.6.5 20.2 2.4 4.6 3.4 4.2 7.6-3.6 44.9-3.9 18.4-7.1 34.2-7.1 35 0 1.2 2 1.5 11.9 1.5 10.5 0 12-.2 12.5-1.8.3-.9 3.8-17 7.8-35.7 8.7-40.7 9.2-47.1 4.3-55.1-3.7-5.9-10.8-9.9-20.5-11.4-9.9-1.5-62.9-1.3-63.5.2zm105.6 3.5c-2.1 9.2-21.1 98.7-21.1 99.5 0 .5 5.5.7 12.2.6l12.3-.3 8.9-41.8 9-41.9 17.6.4c14.7.2 18 .6 20.3 2 4.7 3.2 4.5 5.9-3.2 43-4 18.9-7.5 35.3-7.8 36.5-.5 2.3-.5 2.3 11.9 2.3h12.4l7.8-36.8c8.3-39.6 9-46.5 5.7-53.8-1-2.2-3.6-5.5-5.7-7.2-7.3-6-10.4-6.5-46.5-7l-32.7-.4-1.1 4.9z">
            </path>
            <path fill="#ec443c"
              d="M436 12.5c0 .3 7.4 11.6 16.5 24.9 9.1 13.4 16.7 25 17 25.8.5 1.2-28.5 29.1-52.4 50.5l-3.6 3.2h29l20-18.6c11-10.2 23.5-21.8 27.8-25.8l7.7-7.2-17.8-26.4-17.7-26.4-13.3-.3c-7.2-.1-13.2 0-13.2.3z">
            </path>
            <path
              d="M508.3 29.1C498.2 38.4 490 46.3 490 46.6c0 1.1 10.1 15.4 10.9 15.4.8 0 39.4-35.2 50.6-46.1l4-3.9h-29l-18.2 17.1zm-16.8 47.3-8 7.4 11.1 16.3 11.1 16.4 13.7.3 13.7.3L517 93.3c-8.9-13.1-16.4-23.9-16.8-24-.4-.2-4.3 3.1-8.7 7.1z">
            </path>
          </g>
        </svg>`
});

onMounted(() => {
  window.addEventListener("resize", windowResizeListener);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", windowResizeListener);
});

</script>
<template>
  <div class="tw-px-8 tw-min-w-fit">
    <div
      v-if="type === 'desktop'"
      :style="style"
      class="tw-w-full tw-overflow-visible tw-flex tw-justify-between tw-items-center tw-px-4 tw-gap-x-4"
    >
      <div class="tw-flex tw-items-center tw-w-full tw-overflow-visible">
        <span v-html="svgLogo" />
        <div class="m-header-menu m-header-menu--skin-dark">
          <ul class="m-menu__nav">
            <li
              v-for="link in links"
              class="m-menu__item"
              :class="{
                'm-menu__item m-menu__item--submenu m-menu__item--rel m-menu__item--open-dropdown m-menu__item--hover': link === 'HR Admin'
              }"
            >
              <a class="m-menu__link">
                <span class="m-menu__link-text tw-whitespace-nowrap">{{ link }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="tw-flex tw-justify-start tw-items-center tw-gap-x-2">
        <button
          class="tw-py-4 tw-px-1 tw-relative tw-border-2 tw-border-transparent tw-rounded-full hover focus:tw-outline-none focus tw-transition tw-duration-150 tw-ease-in-out"
          aria-label="Cart"
          type="button"
        >
          <connx-icon
            class="tw-w-6 !tw-h-6"
            style="color: var(--connx-navigation-text)"
            name="fal fa-envelope"
          ></connx-icon>
          <span class="tw-absolute tw-inset-0 tw-object-right-top -tw-mr-6">
            <div
              class="tw-inline-flex tw-items-center tw-w-5 tw-justify-center tw-h-5 tw-border-2 tw-border-connx-white tw-rounded-full tw-text-xs tw-font-semibold tw-leading-4 tw-bg-connx-danger tw-text-connx-white"
            >
              6
            </div>
          </span>
        </button>
        <button
          class="tw-py-4 tw-px-1 tw-relative tw-border-2 tw-border-transparent tw-rounded-full hover focus:tw-outline-none focus tw-transition tw-duration-150 tw-ease-in-out"
          aria-label="Cart"
          type="button"
        >
          <connx-icon
            class="tw-w-6 !tw-h-6"
            style="color: var(--connx-navigation-text)"
            name="fal fa-inbox-in"
          ></connx-icon>
        </button>
        <button
          class="tw-py-4 tw-px-1 tw-relative tw-border-2 tw-border-transparent tw-rounded-full hover focus:tw-outline-none focus tw-transition tw-duration-150 tw-ease-in-out"
          aria-label="Cart"
          type="button"
        >
          <connx-icon
            class="tw-w-6 !tw-h-6"
            style="color: var(--connx-navigation-text)"
            name="fal fa-bell"
          ></connx-icon>
        </button>
        <connx-avatar />
      </div>
    </div>
    <div
      v-else
      :style="style"
      class="tw-mx-auto tw-max-w-96 tw-flex tw-justify-between tw-items-center tw-px-4"
    >
      <connx-icon
        name="fas fa-bars"
        class="tw-w-7 tw-h-auto tw-py-3"
      ></connx-icon>
      <span v-html="svgLogo" />
      <div></div>
    </div>
  </div>

</template>